<lsq-circle-loader *ngIf="!(dataSource.data$ | async)"></lsq-circle-loader>

<!-- No results -->
<div *ngIf="dataSource.noData$ | async" class="no-result-wrapper">
    <lsq-icon [type]="icons.NoDataReport"></lsq-icon>
    <p class="text-text-gray">{{ noDataMessage }}</p>
</div>

<!-- Desktop -->
<div
    class="purchases-grouped-table e2e-grouped-table"
    [ngClass]="{ 'grouped-table-loading': dataSource.loading$ | async }"
    [ngStyle]="{
        display:
            !(isSmallDeviceStream | async) &&
            dataSource &&
            !(dataSource.noData$ | async) &&
            (dataSource.data$ | async)
                ? 'block'
                : 'none'
    }"
>
    <!-- Grouped table header -->
    <purchases-grouped-table-header [dataSource]="dataSource"></purchases-grouped-table-header>

    <!-- Table body -->
    <div class="grouped-table-body">
        <div
            *ngFor="let group of groups; let groupIndex = index"
            class="table-group"
            [ngClass]="{ 'first-group': groupIndex === 0 }"
        >
            <!-- Group heading template -->
            <ng-template #groupHeadingTemplate let-group="group" let-groupIndex="groupIndex">
                <h3 class="group-heading">
                    {{ group.heading | date: dateFormat.LsqShortYear }}
                </h3>
            </ng-template>

            <!-- Group heading -->
            <div
                #normalGroupHeading
                class="static-group-heading"
                [ngClass]="{
                    'is-stuck': groupHeadingsIsStuckStates
                        ? groupHeadingsIsStuckStates[groupIndex]
                        : false
                }"
            >
                <ng-container
                    *ngTemplateOutlet="
                        groupHeadingTemplate;
                        context: { group: group, groupIndex: groupIndex }
                    "
                ></ng-container>
            </div>
            <div
                #stickyGroupHeading
                class="sticky-group-heading stick-to-top"
                [ngClass]="{
                    'is-hidden': groupHeadingsIsStuckStates
                        ? !groupHeadingsIsStuckStates[groupIndex]
                        : true
                }"
                [style.left.px]="leftHeadingPosition"
            >
                <ng-container
                    *ngTemplateOutlet="
                        groupHeadingTemplate;
                        context: { group: group, groupIndex: groupIndex }
                    "
                ></ng-container>
            </div>

            <!-- Accordion rows -->
            <div *ngFor="let row of group.rows; let rowIndex = index" class="expandable-row">
                <purchases-expandable-row
                    [row]="row"
                    [rowPrimaryKey]="rowPrimaryKey"
                    [rowIsExpandable]="true"
                    [expandableRowsService]="expandableRowsService"
                    [fromDateFilter]="dataSource?.request?.fromDateFilter"
                    [toDateFilter]="dataSource?.request?.toDateFilter"
                >
                    <ng-container #errorMessage *ngIf="!!getErrorMessageTemplateRef(row)">
                        <ng-container
                            *ngTemplateOutlet="
                                getErrorMessageTemplateRef(row);
                                context: { $implicit: row }
                            "
                        ></ng-container>
                    </ng-container>
                </purchases-expandable-row>
            </div>
        </div>
    </div>

    <!-- Table pagination -->
    <lsq-data-table-pagination
        *ngIf="isPaginated && !(dataSource.noData$ | async)"
        [skip]="dataSource.skip || 0"
        [take]="dataSource.take || defaultTake"
        [totalCount]="dataSource.totalCount$ | async"
        [takeOptions]="takeOptions"
        [isLoading]="dataSource.loading$ | async"
        (skipChange)="dataSource.handleSkipChange($event)"
        (takeChange)="dataSource.handleTakeChange($event)"
    >
    </lsq-data-table-pagination>
</div>

<!-- Mobile -->
<div
    class="purchases-mobile-grouped-table e2e-grouped-table"
    [ngClass]="{ loading: dataSource.loading$ | async }"
    *ngIf="(isSmallDeviceStream | async) && dataSource"
>
    <div
        *ngFor="let group of groups; let groupIndex = index"
        class="mobile-table-group"
        [ngClass]="{ 'first-group': groupIndex === 0 }"
    >
        <ng-container *ngIf="!(dataSource.noData$ | async)">
            <h3 class="group-heading">
                {{ group.heading | date: dateFormat.LsqShortYear }}
            </h3>

            <purchases-mobile-grouped-table
                [rows]="group.rows"
                [groupIndex]="groupIndex"
                [expandableRowsService]="expandableRowsService"
            >
            </purchases-mobile-grouped-table>
        </ng-container>
    </div>

    <!-- Pagination -->
    <lsq-mobile-table-card-pagination
        *ngIf="isPaginated && (dataSource.data$ | async) && !(dataSource.noData$ | async)"
        [skip]="dataSource.skip || 0"
        [take]="dataSource.take || defaultTake"
        [totalCount]="dataSource.totalCount$ | async"
        [takeOptions]="takeOptions"
        [isLoading]="dataSource.loading$ | async"
        (skipChange)="dataSource.handleSkipChange($event)"
        (takeChange)="dataSource.handleTakeChange($event)"
    >
    </lsq-mobile-table-card-pagination>
</div>
